const FormProgressUtils = require('hooks/useFormPrimitives/progress');
const FormConfig = require('./formConfig');

const ProfileProgressHelpers = module.exports = {};
const PROFILE_PROGRESS_EXTRA_FIELDS = ['sms'];

ProfileProgressHelpers.getSaveProfileProgressFields = ({
    fields = FormConfig.managedFieldNames,
    preferenceProfileFields = []
} = {}) => FormProgressUtils.collectTrackedProgressFields({
    definitions: FormConfig.definitions,
    fields,
    extraFields: preferenceProfileFields.concat(PROFILE_PROGRESS_EXTRA_FIELDS)
});

ProfileProgressHelpers.buildProfileProgressPayload = (payload = {}) => FormProgressUtils.buildProgressPayload({
    payload,
    definitions: FormConfig.definitions
});

ProfileProgressHelpers.getSaveProgressHandlerName = (field, prefix = 'saveProgress') => FormProgressUtils.getProgressHandlerName({
    field,
    prefix
});
